import axiosInstance from "../config/axios.js"

const API_BASE = "/onhire-files"

const onHireFileCabinetService = {
  // Upload single or multiple files
  uploadFiles: async (onhireId, clientId, files) => {
    const formData = new FormData()
    formData.append("onhire_id", onhireId)
    formData.append("client_id", clientId)

    files.forEach((file) => {
      formData.append("files", file)
    })

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  // Get all files for an onhire record
  getFilesByOnHireId: async (onhireId) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { onhire_id: onhireId },
    })
    return response.data
  },

  // Get single file by ID
  getFileById: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete single file
  deleteFile: async (fileId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete multiple files
  deleteMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.delete(`${API_BASE}/delete-multiple`, {
      data: { file_ids: fileIds },
    })
    return response.data
  },

  // Download single file
  downloadFile: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}/download`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download multiple files as ZIP
  downloadMultipleFiles: async (fileIds) => {
    const fileIdParams = fileIds.map((id) => `file_ids=${id}`).join("&")
    const response = await axiosInstance.get(`${API_BASE}/download-multiple?${fileIdParams}`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download all files for an onhire record as ZIP
  downloadByOnHire: async (onhireId) => {
    const response = await axiosInstance.get(`${API_BASE}/download-by-onhire`, {
      params: { onhire_id: onhireId },
      responseType: "blob",
    })
    return response.data
  },

  // Download entire cabinet as ZIP
  downloadAllCabinet: async () => {
    const response = await axiosInstance.get(`${API_BASE}/download-all-cabinet`, {
      responseType: "blob",
    })
    return response.data
  },
}

export default onHireFileCabinetService